module.exports = __webpack_public_path__ + "static/media/Image not available.96c006c0.svg";